export const reviewsSections = [
  `<section class="bg-primary pb-5 pt-5 text-center">
    <div class="container p-5 pb-5 pt-5 text-white">
        <div class="justify-content-center mb-5 row text-center">
            <div class="col-lg-9 col-md-10 col-xl-8">
                <h3 class="fw-bold h1 mb-3 text-capitalize text-white">Kundenstimmen</h3>
                <p class="fs-5 mb-0 text-white">Unsere Kunden vertrauen auf digitale Rechnungsstellung, weil sie schneller, einfacher und transparenter ist. Lesen Sie, was sie dazu sagen:</p>
            </div>
        </div>
        <div class="g-4 justify-content-center mb-5 row row-cols-lg-3 row-cols-md-2 row-cols-xl-4">
            <div>
                <div class="bg-white h-100 p-4 rounded-3 text-black-50">
                    <img src="https://images.unsplash.com/photo-1563306406-e66174fa3787?ixid=M3wyMDkyMnwwfDF8c2VhcmNofDQ5fHx3b21hbnxlbnwwfHx8fDE3NTg2MzkxODN8MA&ixlib=rb-4.1.0q=85&fm=jpg&crop=faces&cs=srgb&w=400&h=400&fit=crop" class="col-sm-9 img-fluid mb-4 p-0 rounded-1" alt="..." width="600" height="600" loading="lazy">
                    <h3 class="fw-bold h4 text-dark">Leona Hartwig</h3>
                    <p class="fw-bolder mb-4 small">Dank der digitalen Rechnungen spare ich wöchentlich mehrere Stunden. Alles läuft endlich effizient und ohne Papierchaos</p>
                </div>
            </div>
            <div>
                <div class="bg-white h-100 p-4 rounded-3 text-black-50">
                    <img src="https://images.unsplash.com/photo-1596075780750-81249df16d19?ixid=M3wyMDkyMnwwfDF8c2VhcmNofDI4fHxtYW58ZW58MHx8fHwxNzU4NjE3NTE4fDA&ixlib=rb-4.1.0q=85&fm=jpg&crop=faces&cs=srgb&w=400&h=400&fit=crop" class="col-sm-9 img-fluid mb-4 p-0 rounded-1" alt="..." width="600" height="600" loading="lazy">
                    <h3 class="fw-bold h4 text-dark">Emir Vuković</h3>
                    <p class="fw-bolder mb-4 small">Ich kann meine Rechnungen direkt vom Smartphone aus erstellen &ndash; das ist perfekt für meinen Arbeitsalltag.</p>
                </div>
            </div>
            <div>
                <div class="bg-white h-100 p-4 rounded-3 text-black-50">
                    <img src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixid=M3wyMDkyMnwwfDF8c2VhcmNofDUyfHx3b21hbnxlbnwwfHx8fDE3NTg2NDUwMTN8MA&ixlib=rb-4.1.0q=85&fm=jpg&crop=faces&cs=srgb&w=400&h=400&fit=crop" class="col-sm-9 img-fluid mb-4 p-0 rounded-1" alt="..." width="600" height="600" loading="lazy">
                    <h3 class="fw-bold h4 text-dark">Saskia Moretti</h3>
                    <p class="fw-bolder mb-4 small">Die automatischen Zahlungserinnerungen haben meinen Cashflow spürbar verbessert. Kunden zahlen jetzt viel schneller.</p>
                </div>
            </div>
            <div>
                <div class="bg-white h-100 p-4 rounded-3 text-black-50">
                    <img src="https://images.unsplash.com/photo-1541577141970-eebc83ebe30e?ixid=M3wyMDkyMnwwfDF8c2VhcmNofDMxfHxtYW58ZW58MHx8fHwxNzU4NjI3MzIyfDA&ixlib=rb-4.1.0q=85&fm=jpg&crop=faces&cs=srgb&w=400&h=400&fit=crop" class="col-sm-9 img-fluid mb-4 p-0 rounded-1" alt="..." width="600" height="600" loading="lazy">
                    <h3 class="fw-bold h4 text-dark">Arvid Jónsson</h3>
                    <p class="fw-bolder mb-4 small">Besonders wichtig war mir die Rechtssicherheit. Hier habe ich volle Transparenz und gleichzeitig ein modernes System.</p>
                </div>
            </div>
        </div>
    </div>
</section>`,
  // 1 — світла класична
  `<section id="reviews1" class="bg-light py-5">
    <div class="container text-center">
      <h2 class="h6 text-primary text-uppercase mb-2">Відгуки</h2>
      <h3 class="fw-bold h2 mb-4">Досвід наших клієнтів</h3>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <blockquote class="bg-white rounded-3 shadow-sm p-4 h-100">
            <p class="mb-3 text-secondary">«WhiteEx допоміг нашій компанії структурувати бухгалтерські процеси. Зручний інтерфейс і прозора логіка роботи!»</p>
            <footer class="fw-bold text-dark">— Анна К., Zürich</footer>
          </blockquote>
        </div>
        <div class="col-md-4 mb-4">
          <blockquote class="bg-white rounded-3 shadow-sm p-4 h-100">
            <p class="mb-3 text-secondary">«Ми перенесли всі наші дані у WhiteEx — це спростило щоденну звітність і зробило все наочно.»</p>
            <footer class="fw-bold text-dark">— Markus L., Bern</footer>
          </blockquote>
        </div>
        <div class="col-md-4 mb-4">
          <blockquote class="bg-white rounded-3 shadow-sm p-4 h-100">
            <p class="mb-3 text-secondary">«Нарешті з’явився інструмент, який дозволяє вести аудит у зрозумілому та логічному форматі.»</p>
            <footer class="fw-bold text-dark">— Julia R., Luzern</footer>
          </blockquote>
        </div>
      </div>
    </div>
  </section>`,

  // 2 — темна версія
  `<section id="reviews2" class="bg-dark text-white py-5">
    <div class="container text-center">
      <h2 class="h6 text-warning text-uppercase mb-2">Відгуки клієнтів</h2>
      <h3 class="fw-bold h2 mb-4">Нам довіряють по всій Швейцарії</h3>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <div class="border border-secondary rounded-3 p-4 h-100">
            <p class="mb-3">«WhiteEx — це стабільність і порядок. Звіти створюються автоматично, а дані завжди під рукою.»</p>
            <footer class="fw-bold text-warning">— Stefan M., Basel</footer>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="border border-secondary rounded-3 p-4 h-100">
            <p class="mb-3">«Дуже зручно для командної роботи. Кожен бачить свою частину процесу, а система все з’єднує.»</p>
            <footer class="fw-bold text-warning">— Lisa F., Genève</footer>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="border border-secondary rounded-3 p-4 h-100">
            <p class="mb-3">«Підтримка реагує швидко. Все налаштовано під потреби бізнесу, без зайвого.»</p>
            <footer class="fw-bold text-warning">— Tobias G., Lausanne</footer>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 3 — кольорова градієнтна
  `<section id="reviews3" class="text-white py-5" style="background:linear-gradient(120deg,#1c1f24,#3a6ea5,#3fb3c3);">
    <div class="container text-center">
      <h2 class="h6 text-uppercase text-light mb-2">Думка користувачів</h2>
      <h3 class="fw-bold h2 mb-4">Що кажуть про WhiteEx</h3>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <div class="bg-white bg-opacity-10 rounded-3 p-4 h-100">
            <p class="mb-3">«Система дозволила нам контролювати фінанси у режимі реального часу. Дуже інтуїтивно!»</p>
            <footer class="fw-bold text-light">— Laura B., Zürich</footer>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="bg-white bg-opacity-10 rounded-3 p-4 h-100">
            <p class="mb-3">«Користуємось щодня. Інтеграція з іншими сервісами працює бездоганно.»</p>
            <footer class="fw-bold text-light">— Nicolas D., Lausanne</footer>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="bg-white bg-opacity-10 rounded-3 p-4 h-100">
            <p class="mb-3">«WhiteEx допоміг побудувати прозору систему управління проектами. Рекомендую!»</p>
            <footer class="fw-bold text-light">— Elina S., Bern</footer>
          </div>
        </div>
      </div>
    </div>
  </section>`,

  // 4 — мінімалістична секція
  `<section id="reviews4" class="bg-white py-5 text-center">
    <div class="container">
      <h2 class="h6 text-uppercase text-muted mb-2">Відгуки користувачів</h2>
      <h3 class="fw-bold h2 mb-4 text-dark">Нам довіряють сотні компаній</h3>
      <div class="row justify-content-center">
        <div class="col-md-4 mb-4">
          <div class="p-4 border rounded-3 shadow-sm h-100">
            <p class="mb-3 text-secondary">«WhiteEx — ідеальне рішення для автоматизації звітності. Все чітко, лаконічно, логічно.»</p>
            <footer class="fw-bold text-dark">— Patrick H., Luzern</footer>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="p-4 border rounded-3 shadow-sm h-100">
            <p class="mb-3 text-secondary">«Після переходу на WhiteEx наші внутрішні процеси стали зрозумілішими. Чудовий досвід!»</p>
            <footer class="fw-bold text-dark">— Marina T., Zürich</footer>
          </div>
        </div>
        <div class="col-md-4 mb-4">
          <div class="p-4 border rounded-3 shadow-sm h-100">
            <p class="mb-3 text-secondary">«WhiteEx — це цифрова дисципліна в найкращому розумінні. Простий інструмент із великою користю.»</p>
            <footer class="fw-bold text-dark">— René S., Basel</footer>
          </div>
        </div>
      </div>
    </div>
  </section>`,
];
